/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Launch_Filter_ProductivityInputs */

const en_directory_launch_filter_productivity = /** @type {(inputs: Directory_Launch_Filter_ProductivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Productivity`)
};

const zh_directory_launch_filter_productivity = /** @type {(inputs: Directory_Launch_Filter_ProductivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`生产力`)
};

/**
* | output |
* | --- |
* | "Productivity" |
*
* @param {Directory_Launch_Filter_ProductivityInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_launch_filter_productivity = /** @type {((inputs?: Directory_Launch_Filter_ProductivityInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Launch_Filter_ProductivityInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_launch_filter_productivity(inputs)
	return zh_directory_launch_filter_productivity(inputs)
});
export { directory_launch_filter_productivity as "directory.launch.filter_productivity" }